import xlsx from "xlsx";

export const bulkUpload = async (
  excelFile,
  postUrl,
  dateColumns = [],
  dataType,
  hasDimension = false
) => {
  try {
    const data = await excelFile.arrayBuffer();
    const wb = xlsx.read(data);

    // Dynamically determine the dimension sheet names
    const dimensionSheetNames = hasDimension ? wb.SheetNames.slice(2) : [];

    const hasDimensionData = hasDimension && dimensionSheetNames.length > 0;

    const sheet = wb.Sheets[wb.SheetNames[1]];
    const jsonSheet = xlsx.utils.sheet_to_json(sheet);
    let convertedData = [];
    let dimensionDataIsSet = false;
    let dimensionDataToSet = null;
    let dimensionDataNameToSet = null;

    // Helper function to format date
    const formatDate = (date) => {
      if (typeof date === "number") {
        // Convert Excel serial number to JS Date object
        const jsDate = xlsx.SSF.parse_date_code(date);
        if (jsDate) {
          return `${String(jsDate.d).padStart(2, "0")}/${String(
            jsDate.m
          ).padStart(2, "0")}/${jsDate.y}`;
        }
      } else if (typeof date === "string") {
        // Ensure the string is in DD/MM/YYYY format
        const dateParts = date.split("/");
        if (dateParts.length === 3) {
          const [dd, mm, yyyy] = dateParts;
          if (dd.length === 2 && mm.length === 2 && yyyy.length === 4) {
            return `${dd}/${mm}/${yyyy}`;
          }
        }
      }
      return date; // return as-is if it's not recognized as a valid date
    };

    // Helper function to trim whitespace from all string values
    const trimValues = (obj) => {
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === "string") {
          obj[key] = obj[key].trim();
        }
      });
    };

    jsonSheet.forEach((row) => {
      // Convert date values to a string format for specified columns

      dateColumns.forEach((column) => {
        if (row[column]) {
          row[column] = formatDate(row[column]);
        }
      });

      // Trim all string values in the row
      trimValues(row);

      // If the dimension data exists, add it to the row for each matching dimension sheet
      if (hasDimensionData) {
        for (const dimensionSheetName of dimensionSheetNames) {
          const dimensionSheet = wb.Sheets[dimensionSheetName];
          const dimensionData = xlsx.utils.sheet_to_json(dimensionSheet);
          // Convert date values to DD/MM/YYYY format for all columns in the dimension data
          dimensionData.forEach((dimensionRow) => {
            for (const column in dimensionRow) {
              if (dimensionRow[column]) {
                dimensionRow[column] = formatDate(dimensionRow[column]);
              }
            }
            // Trim all string values in the dimension data
            trimValues(dimensionRow);
          });

          // Filter dimension data for rows matching the employee's EmployeeNo
          const matchingDimensionData = dimensionData.filter(
            (dimensionRow) => dimensionRow.EmployeeNo === row.EmployeeNo
          );

          if (matchingDimensionData.length > 0) {
            // Create a property for dimension data with the dimensionSheetName
            row[dimensionSheetName] = matchingDimensionData;
            dimensionDataIsSet = true;
          } else if (!dimensionDataIsSet) {
            // Add the dimension data directly to the main data object
            dimensionDataToSet = dimensionData;
            dimensionDataNameToSet = dimensionSheetNames[0];
          }
        }
      }
      convertedData.push(row);
    });

    // If there is dimension data, and it belongs to the main data
    if (hasDimension && !dimensionDataIsSet && dimensionDataToSet) {
      console.log(convertedData);
      convertedData[0][dimensionDataNameToSet] = dimensionDataToSet;
    } else {
      dataType = wb.SheetNames[1];
    }

    // Type values are enums so we need to remove spaces between words
    if (dataType.trim() === "UploadTimeoffLedger") {
      convertedData = convertedData.map((data) => {
        return { ...data, Type: data.Type.split(" ").join("") };
      });
    }

    if (dataType.trim() === "UploadTimeoffJournalLine") {
      convertedData = convertedData.map((data) => {
        return { ...data, EntryType: data.EntryType.split(" ").join("") };
      });
    }

    const jsonData = JSON.stringify({
      [dataType]: convertedData,
    });

    return {
      jsonData,
      count: convertedData.length,
      hasDimensionData,
      dataType,
    };
  } catch (error) {
    console.error("Error during bulk upload:", error);
    return "An error occurred during upload.";
  }
};
